import Component from '../component';

export default class Sidebar extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$metaElement = this.$element.find('.sidebar-meta');
    this.$headerElement = this.$element.find(
      '.sidebar-header, .sidebar-offlineHeader'
    );
    this.$navElement = this.$element.find('.sidebar-nav');
    this.$globalNotification = this.$element.find('.globalNotification');
    this.$switcherElement = this.$element.find('.userSwitcher');

    this.bindEvents();
    this.handleResize();
  }

  bindEvents() {
    this.handleResize = this.handleResize.bind(this);

    window.$window.on('resize.Sidebar', this.handleResize);
  }

  unbindEvents() {
    window.$window.off('resize.Sidebar', this.handleResize);
  }

  handleResize() {
    const includeMargin = true;

    // Calculate the height of the three items we’re stacking
    let maxTop =
      this.$switcherElement.outerHeight(includeMargin) +
      this.$navElement.outerHeight(includeMargin) +
      this.$metaElement.outerHeight(includeMargin) +
      this.$globalNotification.outerHeight(includeMargin);

    if (this.$headerElement.is(':visible')) {
      maxTop += this.$headerElement.outerHeight(includeMargin);
    }

    // If the height of the three items is less than zero, it means that we
    // don’t have enough space to show all three. Let’s make the meta element
    // static so the sidebar scrolls within itself
    const shouldBeStatic = window.$window.height() - maxTop < 0;

    this.$metaElement.toggleClass('sidebar-meta--static', shouldBeStatic);
  }
}
